/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which syntax is supported?`)
};

const es_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué sintaxis se admite?`)
};

const de_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Syntax wird unterstützt?`)
};

const nl_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke syntaxis wordt ondersteund?`)
};

const fr_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle syntaxe est supportée ?`)
};

const it_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale sintassi è supportata?`)
};

const pt_br2_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual sintaxe é suportada?`)
};

const pt_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual sintaxe é suportada?`)
};

const ja_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの構文がサポートされていますか？`)
};

const zh_cr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持哪些语法？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_faq2_q", locale)
	if (locale === "en") return en_cr_faq2_q(inputs)
	if (locale === "es") return es_cr_faq2_q(inputs)
	if (locale === "de") return de_cr_faq2_q(inputs)
	if (locale === "nl") return nl_cr_faq2_q(inputs)
	if (locale === "fr") return fr_cr_faq2_q(inputs)
	if (locale === "it") return it_cr_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_cr_faq2_q(inputs)
	if (locale === "pt") return pt_cr_faq2_q(inputs)
	if (locale === "ja") return ja_cr_faq2_q(inputs)
	return zh_cr_faq2_q(inputs)
};